export const formatFileSize = (bytes: number) => {
    if (!bytes || bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

export const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleString();
    } catch {
      return 'Invalid Date';
    }
  };

 export  const getFileType = (fileName:string) => {
  if (!fileName) return 'unknown';
  const parts = fileName.split('.');
  return parts.length > 1 ? parts.pop()?.toLowerCase() : 'unknown';
};

export const getFilename = (filename:string) => {
  const lastDot = filename.lastIndexOf('.');
  if (lastDot === -1) return filename;

  const baseWithTimestamp = filename.substring(0, lastDot);
  const ext = filename.substring(lastDot + 1);
  const underscoreIdx = baseWithTimestamp.lastIndexOf('_');
  if (underscoreIdx === -1) return filename;

  const possibleTimestamp = baseWithTimestamp.substring(underscoreIdx + 1);
  if (/^\d{10,}$/.test(possibleTimestamp)) {
    const base = baseWithTimestamp.substring(0, underscoreIdx);
    return `${base}.${ext}`;
  }
  return filename;
};
